// import Vue libraries
import Vue from "vue";
import router from "./router";
import store from "./store";
// includes an "install" named export emulating plugin behavior
import * as $request from "./plugins/fetch";
// root application component
import App from "./App";
// Set up internationalization
import i18nMgr from "./plugins/internationalization";
import i18next from "i18next";
import VueI18Next from "@panter/vue-i18next";
// Import languages here
import en from "../i18n/en.json";
// End Import languages
// Set up the Vue plugin for i18next
Vue.use(VueI18Next);
Vue.use(i18nMgr);
i18next.init({
    lng: "en",
    fallbackLng: false,
    keySeparator: false,
    nsSeparator: false,
    resources: {
        en: {
            translation: en
        }
    }
});
const i18n = new VueI18Next(i18next);
// disable an annoying "You are running Vue in development mode" message
Vue.config.productionTip = false;
// inject the fetch controller into components as this.$request
Vue.use($request);
/* eslint-disable no-new */
new Vue({
    el: "#vue-root",
    render: h => h(App),
    i18n,
    i18nMgr,
    router,
    store
});



// WEBPACK FOOTER //
// ./src/main.js